import { render, staticRenderFns } from "./ImageChoice.vue?vue&type=template&id=c496d9c0&scoped=true"
import script from "./ImageChoice.vue?vue&type=script&lang=js"
export * from "./ImageChoice.vue?vue&type=script&lang=js"
import style0 from "./ImageChoice.vue?vue&type=style&index=0&id=c496d9c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c496d9c0",
  null
  
)

export default component.exports